import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { ShowingRequestStatus, ShowingStatus, useShowingsQuery } from '@tallo/investor/showing';

export function useRenterShowings() {
  const { state } = useShowingsQuery();
  const route = useRoute();
  const renterId = computed(() => route.params.renterId);

  const showings = computed(() => {
    return (state.value.data || [])
      .map((showing) => {
        return {
          ...showing,
          showingRequests: showing.showingRequests.filter(({ renter, status }) => {
            const isActive = [ShowingRequestStatus.PENDING, ShowingRequestStatus.ACCEPTED].includes(status);

            return renter.id === renterId.value && isActive;
          }),
        };
      })
      .filter(({ showingRequests, status }) => {
        const hasShowingRequests = showingRequests.length > 0;
        const isActive = [ShowingStatus.PENDING, ShowingStatus.CONFIRMED].includes(status);

        return isActive && hasShowingRequests;
      });
  });

  return {
    ...state,
    showings,
  };
}
